import {KU_TYPE} from '@/constants/document/doc';

export const LOG_TYPE = {
    current: 'current',
    period: 'period',
};

export enum CATEGORY {
    load = 'load',
    edit = 'edit',
    preview = 'preview',
    history = 'history',
    meeting = 'meeting',
}

export const LOG_DOC_TYPE = {
    sheet: 'sheet', // 表格性能上报复用文档埋点，通过docType进行区分
    doc: 'doc', // 文档
    ppt: 'ppt', // 演示文稿
    datasheet: 'datasheet', // 数据表
} as const;

export type LogDocType = typeof LOG_DOC_TYPE[keyof typeof LOG_DOC_TYPE];

// docType对应的埋点上报字段, 如果没匹配上就默认是doc
export const LOG_DOC_TYPE_MAP = {
    [KU_TYPE.Doc]: 'doc',
    [KU_TYPE.Book]: 'doc',
    [KU_TYPE.Repo]: 'doc',
    [KU_TYPE.Sheet]: 'sheet',
    [KU_TYPE.PPT]: 'ppt',
    [KU_TYPE.DataSheet]: 'datasheet',
};

export const DELAY = 5000;
